<template>
	<div class="homepage_container">
		<div class="body-main">

			<!-- 教师特训营 -->
			<div style="width: 100%; display: flex; flex-direction: column;">
				<div>
					<el-carousel :interval="5000" arrow="hover" :height="screenWidth">
						<el-carousel-item v-for="(item,index) in banner"
							v-if="(banner.length>4 && index<banner.length-2) || (banner.length<5 && index > -1)">
							<img @click="toCampDetail(item)" style="cursor: pointer;" :src='item.img_url' width="100%"
								height="100%" />
						</el-carousel-item>
					</el-carousel>
				</div>

				<div style="width: 100%; display: flex; justify-content: space-between;">
					<div v-for="(item,index) in banner" v-if="index == banner.length-2 || index == banner.length-1"
						@click="toCampDetail(item)"
						style="display: inline-flex; flex: 1; margin-top: 10px;position: relative;cursor: pointer;"
						:class="{'margin_right_10':index ==banner.length-2}">
						<img :src='item.img_url_index_other' style="width: 100%;" />
						<div
							style="width: 52px; height: 58px; display: inline-flex; flex-direction: column; justify-content: center;align-items: center; background-color:#F6892E ; color: #fff; font-weight: 600;  box-sizing: border-box; position: absolute; top: 0; right: 36px;">
							<div style="font-size: 22px; border-bottom: 2px solid #fff;">{{item.month}}月</div>
							<div style="font-size: 15px;">{{item.year}}</div>
						</div>
					</div>
				</div>
			</div>


			<!-- 特训营 -->
			<div class="panel_container" v-if="campList && campList.length > 0">
				<div class="panel_inner">
					<div class="panel_hd">
						<div class="panel_hd-lf">
							<div class="line_left"></div>
							<div class="title_box">
								<div class="title">特训营</div>
								<div class="summary" style="">正在报名中</div>
							</div>
						</div>

						<div class="panel_hd-rt" @click="toList(27)">
							更多特训营<i class="el-icon-d-arrow-right icon"></i>
						</div>
					</div>
					<div class="panel_bd">
						<!-- 切换卡 -->
						<div class="tabs">
							<div class="tab" :class="{'actived':selected.id == item.id}"
								v-for="(item,index) in campList" @mousemove="selectClick(item)">{{item.title_m}}</div>
						</div>
						<!-- 切换内容 -->
						<div class="tab_content" v-if="selected" @click="toCampDetail(selected)">
							<!-- 特训营封面 -->
							<img class="cover" :src="selected.img_url_compressed" />
							<!-- 特训营信息 -->
							<div class="info">
								<div class="title">
									{{selected.title}}
								</div>
								<div class="exts">
									<div><i class="el-icon-time icon" style=""></i>举办时间：{{selected.time}}</div>
									<div><i class="el-icon-location-outline icon"></i>举办地点：{{selected.place}}</div>
								</div>
							</div>
							<!-- 倒计时卡片 -->
							<div class="countdown_card">
								<div class="data_box" v-if="selected.ts_start_at!=0">
									<div>距离特训营开始仅剩</div>
									<div class="time_box">
										<span class="time">{{selected.ts_start_at}}</span>
										<span class="text">天</span>
									</div>
								</div>
								<div class="data_box" v-if="selected.ts_start_at==0">
									目前仍可报名
								</div>
								<div class="btn">
									立即报名
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>
			
			
			

			<!-- 课程 -->
			<div class="panel_container">
				<img class="image_bg" src="../../assets/images/bg_index_course_01.png" />
				<div class="panel_inner">
					<div class="panel_hd">
						<div class="panel_hd-lf">
							<div class="line_left"></div>
							<div class="title_box">
								<div class="title">课程</div>
								<div class="summary">如何有效用好一本书，教好一门课</div>
							</div>
						</div>


						<div class="panel_hd-rt" @click="toList(4)">
							更多课程<i class="el-icon-d-arrow-right icon"></i>
						</div>
					</div>

					<div class="course_list">
						<div class="item" v-for="(item,index) in productData.list" @click="toCourseDetail(item)">
							<img class="cover" :src="course_img_url" v-if="item.img_url_tt==''" />
							<img class="cover" :src="item.img_url_tt" v-if="item.img_url_tt!=''" />
							<div class="info">
								<div class="title_box">
									<div class="title">{{item.title}}</div>
									<!-- <div class="author">主讲人：{{item.author}}</div> -->
								</div>
								<div class="exts_box">
									<div class="res_info">
										<div class="res_count">{{item.res_count}}小节</div>
										<div class="res_length"><i
												class="el-icon-pie-chart icon"></i>{{item.res_length}}</div>
									</div>

									<div class="price" v-if="item.is_office_product != 1">
										<span v-if="item.price!='0.00'">¥{{item.price}}</span>
										<span v-if="item.price=='0.00'">免费</span>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			
			<!-- 系列课 -->
			<div class="panel_container">
				<img class="image_bg" src="../../assets/images/bg_index_course_01.png" />
				<div class="panel_inner">
					<div class="panel_hd">
						<div class="panel_hd-lf">
							<div class="line_left"></div>
							<div class="title_box">
								<div class="title">系列课</div>
								<div class="summary">让学习从平面走向立体</div>
							</div>
						</div>
			
			
						<div class="panel_hd-rt" @click="toList(36)">
							更多系列课<i class="el-icon-d-arrow-right icon"></i>
						</div>
					</div>
			
					
					<div class="album_list">
						<div class="item" v-for="(item,index) in albumList" @click="toAlbumDetail(item)">
							<img class="cover" :src="item.img_url" />
						</div>
					</div>
				</div>
			</div>

			<!-- 教研室 -->
			<div class="room_panel_container">
				<!-- <img src="../../assets/images/bg_index_edu_01.png"  style="min-width: 100%; overflow: hidden;"/> -->
				<div class="panel_inner">
					<div class="panel_lf">
						<div class="panel_lf-hd">
							<div class="line_left"></div>
							<div class="title_box">
								<div class="title">数字教研室</div>
								<div class="summary">提升教学实践系统能力的成长圈子</div>
							</div>
						</div>

						<div class="panel_lf-bd">
							<div class="title">
								《投资学原理及应用》
							</div>
							<div class="author">
								贺显南
							</div>
							<div class="desc">
								广东外语外贸大学金融学院教授<br />
								《投资学原理及应用》作者
							</div>
							<div class="btn" @click="toRoomDetail">
								了解详情
							</div>
						</div>
					</div>
					<div class="panel_rt">
						<img class="img" :src="digital_office_img_url" />
					</div>
				</div>
			</div>





			<!-- 名师团 -->
			<div class="panel_container teacher">

				<div class="panel_inner">
					<div class="panel_hd">
						<div class="panel_hd-lf">
							<div class="line_left"></div>
							<div class="title_box">
								<div class="title">名师团</div>
								<div class="summary">改变自己，从关注自己身边的榜样开始</div>
							</div>
						</div>
					</div>
				</div>


				<div v-if="typeSelected" style="display:flex; z-index: 333; width: 100%;  position: relative; justify-content: center; align-items: center; height: 400px;">
					<!-- <img src="../../assets/images/bg_index_teacher_01.png"  style="min-width: 100%; overflow: hidden;"/> -->
					<div style="display: flex;  width: 1200px; height: 400px; justify-content: center;  align-items: center;">
						<div style="width: 320px;line-height: 1;display: inline-flex;flex-direction: column;">
							<div style="color: #C63D33; font-size: 48px;font-weight: 600;">{{typeSelected.title}}</div>
							<div style="color: #999; font-size: 23px;margin-top: 15px;">{{typeSelected.title_en}}</div>
							<!-- <div
								style="color: #999; font-size: 17px; text-align: justify;line-height: 1.2; margin-top: 30px;">
								改变自己，从关注自己身边的榜样开始</div> -->
						</div>
						<div style="flex: 1; display: flex; align-items: flex-end;height: 400px;">
							<img :src="typeSelected.img_url" style=" height: 365px;" />
						</div>
					</div>
				</div>
			</div>


			<div class="type_data_box">
				<img class="icon_arrow" src='../../assets/images/icon_arrow_left.png' />
				<div class="type_data_item"
					:class="{'disabled':item.disabled,'actived':item.title == typeSelected.title}"
					v-for="(item,index) in typeData" @click="changeType(item)">
					<div class="type_data_title" style="">{{item.title}}</div>
					<div class="type_data_title_en">{{item.title_en}}</div>
				</div>
				<img class="icon_arrow" src='../../assets/images/icon_arrow_right.png' />
			</div>

		</div>
	</div>
</template>

<script>
	import apiUrl from "../../js/apiUrl.js";
	import comm from "../../js/comm.js";


	export default {
		data() {
			return {
				productData: {
					total: 0,
					count: 0,
					list: [],
				},
				banner: [],
				course_img_url: require("../../assets/images/cover.png"),
				digital_office_img_url: require("../../assets/images/bg_index_edu_02.png"),
				typeData: [{
					title: "机械",
					title_en: "Mechanical",
					img_url: "",
					disabled: true,
				}, {
					title: "电气及自动化",
					title_en: "Electrical and Automation",
					img_url: "",
					disabled: true,
				}, {
					title: "电子信息",
					title_en: "Digital Information",
					img_url: "",
					disabled: true,
				}, {
					title: "计算机",
					title_en: "Computer",
					img_url: "",
					disabled: true,
				}, {
					title: "汽车",
					title_en: "Automobile",
					img_url: "",
					disabled: true,
				}, {
					title: "经济",
					title_en: "Economics",
					img_url: require("../../assets/images/bg_index_teacher_02_new.png"),
					disabled: false,
				}, {
					title: "管理",
					title_en: "Management",
					img_url: require("../../assets/images/bg_index_teacher_01_new.png"),
					disabled: false,
				}],
				typeSelected: null,
				screenWidth: (document.documentElement.clientWidth * 720) / 1920 + 'px',
				campList: null,
				albumList: null,
				selected: null,
			};
		},
		created() {
			document.title = "机工教师特训营";
			this.getBanner();
			this.getProductList();
			this.changeType(this.typeData[5]);
			this.getCampList();
			this.getAlbumList();
		},
		mounted() {
			window.onresize = () => {
				return (() => {
					if (document.documentElement.clientWidth > 960) {
						this.screenWidth = (document.documentElement.clientWidth * 720) / 1920 + 'px';
					}
				})();
			}
		},
		beforeRouteEnter(to, from, next) {
			next(vm => {
				if (vm.isMobilePhone()) {
					window.location.href = 'https://m.cmptt.com';
				}
			});
		},
		methods: {
			isMobilePhone() {
				const ua = navigator.userAgent.toLowerCase();
				const t1 =
					/android|webos|iphone|ipod|blackberry|iemobile|opera mini|opera mobile|applewebkit.*mobile|mobile/i
					.test(ua);
				return t1;
			},
			toList(product_type) {
				this.GoToChangeTab(product_type);
			},
			changeType(item) {
				if (item.disabled) {
					return;
				}
				this.typeSelected = item;
			},
			toCampDetail(item) {
				if (!item.id) {
					this.$alert('特训营正在紧张筹备中，敬请期待······', '温馨提示', {
						confirmButtonText: '确定'
					});
					return;
				}
				this.GoToDetail(item.product_type, item.id);
			},
			toRoomDetail(item) {
				/*
				var url = "/teachRoom/detail";
				var query = { id: item.id };
				let routeUrl = this.$router.resolve({
					path: url,
					query: query,
				});
				window.open(routeUrl.href, "_blank");
				*/
				var url = "/teachRoom/detail";
				var query = {
					id: '9ea73161ee334b79a2ef0575316a088b'
				};
				let routeUrl = this.$router.resolve({
					path: url,
					query: query,
				});
				window.open(routeUrl.href, "_blank");
			},
			toAlbumDetail(item){
				var url = '/album/detail';
				var query = {
					id: item.id,
				};
				let routeUrl = this.$router.resolve({
					path: url,
					query: query,
				});
				window.open(routeUrl.href, "_blank");
			},
			toCourseDetail(item) {
				var url = '/course/detail';
				var query = {
					id: item.id,
					//tt_camp_id: this.id
				};
				let routeUrl = this.$router.resolve({
					path: url,
					query: query,
				});
				window.open(routeUrl.href, "_blank");
			},
			toWebcastDetail(item) {
				if (!item.webcast_url) {
					this.$alert('直播间正在创建中..', '提示', {
						confirmButtonText: '确定'
					});
				} else {
					window.location.href = item.webcast_url;
				}
			},

			clickTag(name) {
				var url = "/teachRes/taglist";
				var query = {
					tag_name: name
				};
				let routeUrl = this.$router.resolve({
					path: url,
					query: query,
				});
				window.open(routeUrl.href, "_blank");
			},
			getProductList() {
				var that = this;
				var url = apiUrl.tt_course_list_get;
				this.Ajax(url, {
					page_index: 1,
					page_size: 8,
					order_by: 'random:asc',
				}, (data) => {
					if (that.productData.total == 0) {
						that.productData.total = data.total;
					}
					if (that.productData.count == 0) {
						that.productData.count = data.count;
					}
					that.productData.list = data.list;

					//console.log('productData' + JSON.stringify(that.productData))
				});
			},
			getBanner() {
				var that = this;
				var url = apiUrl.tt_camp_list_get;
				this.Ajax(url, {
					page_index: 1,
					page_size: 20,
					order_by: '',
					state: 1
				}, (data) => {
					that.banner = data.list;
				});
			},
			getCampList() {
				var that = this;
				var url = apiUrl.tt_camp_list_get;
				var parm = {
					page_index: 1,
					page_size: 6,
					order_by: '',
					is_top: 1
				};
				this.Ajax(url, parm, (data) => {
					if (data && data.list) {
						that.campList = data.list;
						if(that.campList && that.campList.length>0){
							that.selected = that.campList[0];
						}
					}
				});
			},
			getAlbumList() {
				var that = this;
				var url = apiUrl.tt_album_list_get;
				var parm = {
					page_index: 1,
					page_size: 6,
					order_by: 'random:asc'
				};
				this.Ajax(url, parm, (data) => {
					if (data && data.list) {
						that.albumList = data.list;
					}
				});
			},
			selectClick(item) {
				this.selected = item;
			}
		},
	};
</script>

<style>
	.el-carousel__item h3 {
		color: #475669;
		font-size: 14px;
		opacity: 0.75;
		line-height: 150px;
		margin: 0;
	}

	.el-carousel__item:nth-child(2n) {
		background-color: #99a9bf;
	}

	.el-carousel__item:nth-child(2n+1) {
		background-color: #d3dce6;
	}
</style>

<style lang="scss" scoped>
	.homepage_container {
		width: 100%;
		min-height: 100vh;
		background: #fff;

		.body-main {
			width: 100%;
			display: flex;
			flex-direction: column;
			align-items: center;
			background: #fff;
			//padding: 10px 0;
			box-sizing: border-box;
		}

		.margin_right_10 {
			margin-right: 10px;
		}

		.type_data_box {
			display: flex;
			width: 100%;
			height: 220px;
			justify-content: space-around;
			align-items: center;
			background-color: #fff;

			.icon_arrow {
				width: 30px;
				height: 30px;
				cursor: pointer;
			}

			.type_data_item {
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
				border: 2px solid #ccc;
				width: 160px;
				height: 140px;

				&.disabled {
					.type_data_title {
						color: #ccc;
					}

					.type_data_title_en {
						font-size: 12px;
						color: #ddd;
					}
				}

				&:not(.disabled):hover,
				&.actived {
					background-color: #f1f1f1;
					cursor: pointer;
				}

				.type_data_title {
					font-size: 21px;
					color: #333;
				}

				.type_data_title_en {
					font-size: 12px;
					color: #999;
				}


			}
		}

		// 教研室板块
		.room_panel_container {
			display: flex;
			z-index: 333;
			position: relative;
			justify-content: center;
			align-items: center;
			width: 100%;
			height: 560px;
			box-shadow: inset 0px -20px 20px rgba(0, 0, 0, 0.04);

			.panel_inner {
				display: inline-flex;
				width: 1200px;
				height: 560px;

				.panel_lf {
					display: flex;
					flex-direction: column;

					.panel_lf-hd {
						display: flex;
						margin: 45px 0 65px 0;

						.line_left {
							margin-right: 10px;
							width: 5px;
							background: linear-gradient(to bottom, #ff9000, #c93a2e);
						}

						.title_box {
							display: flex;
							flex-direction: column;
							line-height: 1;

							.title {
								font-size: 28px;
								color: #333;
							}

							.summary {
								font-size: 17px;
								color: #999;
								margin-top: 10px;
							}
						}
					}

					.panel_lf-bd {
						display: flex;
						flex-direction: column;

						.title {
							display: flex;
							font-size: 40px;
							font-weight: 600;
							color: #333;
						}

						.author {
							display: flex;
							font-size: 28px;
							color: #333;
							margin-top: 35px;
						}

						.desc {
							display: flex;
							font-size: 20px;
							color: #999;
							line-height: 1.4;
						}

						.btn {
							display: inline-flex;
							justify-content: center;
							align-items: center;
							color: #fff;
							font-size: 20px;
							width: 132px;
							height: 40px;
							border-radius: 40px;
							background: linear-gradient(to right, #c93a2e, #F6892E);
							margin-top: 50px;
							cursor: pointer;
						}
					}
				}

				.panel_rt {
					flex: 1;
					height: 560px;
					z-index: 1;
					display: flex;
					flex-direction: column;
					justify-content: flex-end;
					align-items: center;

					.img {
						width: 520px;
						margin-top: 30px;
					}
				}
			}
		}

		// 特训营/系列课/课程板块
		.panel_container {
			display: flex;
			width: 100%;
			position: relative;
			display: flex;
			flex-direction: column;
			background-color: #fff;
			justify-content: center;
			align-items: center;
			position: relative;
			overflow: hidden;
			z-index: 4;
			
			&.teacher{
				background-color: #FDEBDB;
				
				.panel_inner{
					.panel_hd{
						margin: 60px 0 20px 0 !important;
					}
				}
			}

			.image_bg {
				width: 100%;
				position: absolute;
				top: 0;
				z-index: 2;
			}

			.panel_inner {
				display: inline-flex;
				flex-direction: column;
				width: 1200px;
				z-index: 3;

				.panel_hd {
					display: flex;
					justify-content: space-between;
					margin: 45px 0 35px 0;

					.panel_hd-lf {
						display: flex;

						.line_left {
							margin-right: 10px;
							width: 5px;
							background: linear-gradient(to bottom, #ff9000, #c93a2e);
						}

						.title_box {
							display: flex;
							flex-direction: column;
							line-height: 1;

							.title {
								font-size: 28px;
								color: #333;
							}

							.summary {
								font-size: 17px;
								color: #999;
								margin-top: 10px;
							}
						}
					}

					.panel_hd-rt {
						display: flex;
						align-items: center;
						line-height: 1;
						color: #999;
						font-size: 20px;
						cursor: pointer;
						padding-top: 18px;

						.icon {
							margin-left: 5px;
						}
					}
				}

				.panel_bd {
					display: flex;
					flex-direction: column;

					.tabs {
						display: flex;
						flex-wrap: wrap;
						width: 100%;
						border-bottom: 1px solid #c93a2e;

						.tab {
							font-size: 16px;
							height: 50px;
							font-weight: 200;
							width: calc((100% - 50px)/ 6);
							display: flex;
							justify-content: center;
							align-items: center;
							background: #F4F5F6;
							color: #111;
							margin-right: 10px;
							border: 1px solid #c93a2e;
							border-bottom: none !important;
							box-sizing: border-box;
							cursor: pointer;


							&:nth-child(6n+6) {
								margin-right: 0 !important;
							}

							&.actived {
								background: #c93a2e !important;
								color: #F4F5F6 !important;
								font-weight: 600;
							}
						}
					}

					.tab_content {
						display: flex;
						padding: 30px;
						box-sizing: border-box;
						line-height: 1.4;
						border: 1px solid #c93a2e;
						border-top: 0px solid #c93a2e !important;
						cursor: pointer;

						.cover {
							width: 400px;
							margin-right: 20px;
						}

						.info {
							flex: 1;
							display: flex;
							flex-direction: column;
							justify-content: space-between;

							.title {
								font-size: 20px;
								text-align: justify;
								display: -webkit-box;
								overflow: hidden;
								text-overflow: ellipsis;
								line-clamp: 3;
								-webkit-line-clamp: 3;
								-webkit-box-orient: vertical;
								max-height: calc(1.4em * 3);
							}

							.exts {
								display: flex;
								flex-direction: column;
								justify-content: space-between;
								font-size: 16px;
								line-height: 1.5;

								.icon {
									margin-right: 5px;
								}
							}
						}

						.countdown_card {
							width: 278px;
							border-left: 1px dashed #eee;
							margin-left: 30px;
							padding-left: 30px;
							box-sizing: border-box;
							display: flex;
							flex-direction: column;
							justify-content: space-between;
							align-items: center;

							.data_box {
								display: flex;
								flex-direction: column;
								align-items: center;
								font-size: 20px;
								color: #333;

								.time_box {
									display: flex;
									align-items: center;

									.time {
										font-size: 48px;
										color: #c93a2e;
										font-weight: 600;
									}

									.text {
										font-size: 16px;
										color: #333;
										margin-left: 5px;
										margin-bottom: -10px;
									}
								}
							}

							.btn {
								width: 100%;
								height: 48px;
								display: flex;
								justify-content: center;
								align-items: center;
								border: 1px solid #c93a2e;
								font-size: 18px;
								color: #c93a2e;
								box-sizing: border-box;
							}
						}
					}
				}
				
				//系列课
				.album_list{
					display: flex;
					flex-direction: row;
					flex-wrap: wrap;
					margin-top: 20px;
					width: 100%;
					
					.item{
						width: 380px;
						height: 190px;
						margin-right: 30px;
						margin-bottom: 30px;
						cursor: pointer;
						
						&:nth-child(3n+3) {
							margin-right: 0;
						}
						
						.cover{
							width: 100%;
							height: auto;
						}
					}
				}

				.course_list {
					display: flex;
					flex-direction: row;
					flex-wrap: wrap;
					margin-top: 20px;

					.item {
						width: 280px;
						height: 265px;
						margin-right: 20px;
						margin-bottom: 40px;
						cursor: pointer;
						overflow: hidden;
						display: flex;
						flex-direction: column;
						border-radius: 20px;

						&:nth-child(4n+4) {
							margin-right: 0;
						}

						&:hover {
							box-shadow: -1px 2px 5px 0 rgba(0, 0, 0, 0.1);
							border-radius: 20px;
						}

						.cover {
							width: 100%;
						}

						.info {
							flex: 1;
							background-color: #F1F1F1;
							display: flex;
							flex-direction: column;

							.title_box {
								flex: 1;
								display: flex;
								flex-direction: column;
								padding: 15px 10px 10px 15px;

								.title {
									font-size: 20px;
									font-weight: 600;
									line-height: 1.2;
								}

								.author {
									font-size: 18px;
									line-height: 1;
									margin-top: 8px;
								}
							}

							.exts_box {
								width: 100%;
								height: 40px;
								border-radius: 0 0 20px 20px;
								border-top: 1px solid #E8E8E8;
								display: flex;
								justify-content: space-between;
								align-items: center;
								padding: 0 17px 0 20px;
								box-sizing: border-box;

								.res_info {
									display: flex;
									font-size: 13px;
									align-items: center;

									.res_count {
										background-color: #c93a2e;
										color: #fff;
										padding: 2px 8px;
										border-radius: 20px;
									}

									.res_length {
										margin-left: 8px;

										.icon {
											margin-right: 2px;
										}
									}
								}

								.price {
									font-weight: 600;
									font-size: 17px;
									color: #c93a2e;
								}
							}
						}
					}
				}
			}
		}
	}
</style>